import { TestBed } from '@angular/core/testing';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from '../../users/data/services/account.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-delete-outstation',
  templateUrl: './delete-outstation.component.html',
  styleUrls: ['./delete-outstation.component.sass']
})
export class DeleteOutstationComponent implements OnInit {
  outstationProperties: any


  constructor(
    public dialogRef: MatDialogRef<DeleteOutstationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService, // Inject the AccountService
    private snackbar: SnackbarService
  ) { }

  ngOnInit(): void {
    this.outstationProperties = this.data.test;
    console.log(this.outstationProperties);
    console.log('Outstation ID to delete:', this.outstationProperties.id);

  }

  onDeleteClick(): void {
    this.accountService.deleteOutstation(this.outstationProperties.id).subscribe(
      (response) => {
        // Handle success
        console.log("Outstation deleted successfully", response);
        // You may want to refresh the data or perform other actions after deletion.
        this.snackbar.showNotification('snackbar-success', 'Outstation deleted successfully!');
      },
      (error) => {
        // Handle error
        console.error("Error deleting Outstation", error);
        this.snackbar.showNotification('snackbar-danger', 'Error deleting outstation, see console for more details');
      }
    );
    this.dialogRef.close(true); // Close the dialog and indicate success
  }


}
